import Vue from 'vue'

const state = {
  num_rows: 5
}

const actions = {
    SET_NUM_ROWS(context, [num_rows]) {
        let rows = num_rows >= 5 ? num_rows : 5
        context.commit('SAVE_NUM_ROWS', [rows])
    }
}

const mutations = {
    SAVE_NUM_ROWS: (state, [num_rows]) => {
      Vue.set(state, 'num_rows', num_rows)
    }
}

const getters = {
    num_rows: state => {
        return state.num_rows
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
